import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import Dialog from '../../common/components/Dialog';
import NewFormSettings from './NewFormSettings';
import RemoteSubmitButton from '../../common/components/formControls/RemoteSubmitButton';
import { withTranslation } from 'react-i18next';

class NewFormDialog extends Component {
	renderBody() {
		const { forms, onConfirm } = this.props;
		return <NewFormSettings forms={forms} onSubmit={onConfirm} />;
	}

	renderFooter() {
		const { onCancel, t } = this.props;

		const closeBtn = <Button key='close' onClick={onCancel}>{t('Common_Close')}</Button>;
		const confirmBtn = <RemoteSubmitButton key='save' style='primary' formName='newFormSettings' label={t('IndividualConsultationForm_Add')} />;
		return [closeBtn, confirmBtn];
	}

	render() {
		const { t, show, onCancel, block, unblock } = this.props;
		const dialogOptions = {
			header: t('IndividualConsultationForm_New'),
			body: this.renderBody(),
			onHide: onCancel,
			footer: this.renderFooter()
		};

		return (
			<Dialog config={dialogOptions} show={show} t={t} block={block} unblock={unblock} />
		);
	}
}

export default withTranslation()(NewFormDialog);